export default {"src":"/_next/static/media/lemons.5e87ad04.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};